import { Injectable } from "@angular/core";
import { FormMapaATControlNames } from "../../formMapaATControlNames";
import { TypeAutresInfosATTR } from "../../models/TypeAutresInfosATTR";
import { TypeMontant } from "../../models/TypeMontant";
import { AvisDataTransferService } from "../../../../../shared/services/avis-data-transfer.service";

@Injectable({
    providedIn: 'root'
})
export class AutresInformationsService {

    constructor(private avisDataTransferService: AvisDataTransferService) {
    }

    public getAutresInformations(controls, stepId): TypeAutresInfosATTR {

        const autresInformations = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa.attributionFromMAPA.autresInformations;
        if (stepId == 3) {
            autresInformations.dateAttribution = controls.get(FormMapaATControlNames.dateAttribution);
              //PRB0053902: Comme le formulaire attend une date, il serait judicieux de fournir une donnée au format date plutôt que <date>T<heure>.
              //+ controls.get(FormMapaATControlNames.dateAttribution + '_timestamp');
            autresInformations.valeurTotaleEstimee = new TypeMontant();
            autresInformations.valeurTotaleEstimee.devise = controls.get('_SepSep_AttributionFromMAPA_SepSep_TypeAutresInfosATTR_valeurTotaleEstimee_SepSep_TypeMontant_SepAtt_devise')
            autresInformations.valeurTotaleEstimee.valeur = controls.get('_SepSep_AttributionFromMAPA_SepSep_TypeAutresInfosATTR_valeurTotaleEstimee_SepSep_TypeMontant_SepAtt_valeur')
        }
        if (stepId == 7) {
            autresInformations.nbOffresRecues = controls.get('_SepSep_AttributionFromMAPA_SepSep_TypeAutresInfosATTR_SepAtt_nbOffresRecues')
            autresInformations.informations = controls.get('_SepSep_AttributionFromMAPA_SepSep_TypeAutresInfosATTR_SepAtt_informations')
            autresInformations.nbParticipants = controls.get('_SepSep_AttributionFromMAPA_SepSep_TypeAutresInfosATTR_SepAtt_nbParticipants')
            autresInformations.nbParticipantsEtrangers = controls.get('_SepSep_AttributionFromMAPA_SepSep_TypeAutresInfosATTR_SepAtt_nbParticipantsEtrangers')

            autresInformations.primeAttribuee = new TypeMontant();
            autresInformations.primeAttribuee.devise = controls.get('_SepSep_AttributionFromMAPA_SepSep_TypeAutresInfosATTR_primeAttribuee_SepSep_TypeMontant_SepAtt_devise')
            autresInformations.primeAttribuee.valeur = controls.get('_SepSep_AttributionFromMAPA_SepSep_TypeAutresInfosATTR_primeAttribuee_SepSep_TypeMontant_SepAtt_valeur')
        }
        return autresInformations;
    }
}
